import React from 'react';
import AddImage, { ImageFileType } from '@/components/admin/ImageManager/Add';
import { useModalManager } from 'components/common/Modal';
import { ApolloProvider } from '@apollo/client';
import apolloClient from '@/components/common/ApolloClient';
import { useExcludedFields } from '@/components/admin/QuestionImage/utils';

interface AddProps {
  afterSubmit: (imageModel: object) => any;
  buttonText?: 'Add Image' | 'Add GIF' | 'Add Answer Image',
  excludeImageFileTypes?: ImageFileType[],
  forAnswerKey?: boolean;
  forQuestionBuilder?: boolean;
  mediaType: string;
  modalOverlayClassName?: string;
  modelId: number;
  modelType: 'Question' | 'QuestionGroup';
  userType: UserType;
}

const Add = ({
  afterSubmit,
  buttonText = 'Add Image',
  excludeImageFileTypes = [],
  forAnswerKey = false,
  forQuestionBuilder = false,
  mediaType,
  modalOverlayClassName = '',
  modelId,
  modelType,
  userType,
}: AddProps) => {
  const modalManager = useModalManager();
  const excludeFields = useExcludedFields(userType);
  const mediaMeta = forAnswerKey ? { type: 'answer' } : {};

  return (
    <AddImage
      fromSlideShow
      afterMergeDuplicates={afterSubmit}
      afterSubmit={afterSubmit}
      buttonClass="!tw-mb-0"
      buttonText={buttonText}
      dontMergeCallback={afterSubmit}
      excludeFields={excludeFields}
      excludeImageFileTypes={excludeImageFileTypes}
      forQuestionBuilder={forQuestionBuilder}
      headerText={buttonText}
      isAdmin={userType === 'Admin' || userType === 'Sysadmin' || userType === 'ContentManager'}
      mediaMeta={mediaMeta}
      mediaType={mediaType}
      modalManager={modalManager}
      modalOverlayClassName={modalOverlayClassName}
      modelId={modelId}
      modelType={modelType}
    />
  );
};

const QuestionImageAddWrapper = (props: AddProps) => (
  <ApolloProvider client={apolloClient}>
    <Add {...props} />
  </ApolloProvider>
);

export default QuestionImageAddWrapper;
